import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  Component,
  TemplateRef,
  ViewChild,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GeneralContactComponent } from '../../../components/general-contact/general-contact.component';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { EquipmentListSubcategory } from '../../models/equipmentList.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CompareService } from '../../../services/compare.service';

@Component({
  selector: 'app-card-list',
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterLink,
    MatCheckboxModule,
    MatDialogModule,
    MatSnackBarModule,
    GeneralContactComponent,
  ],
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss',
})
export class CardListComponent {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly compareService = inject(CompareService);
  private _snackBar = inject(MatSnackBar);

  // Input como Signal
  card = input.required<EquipmentListSubcategory>();
  show = input<boolean>(true);
  showBtnRemove = input<boolean>(false);

  @ViewChild('modalContactCard')
  modalContactCard!: TemplateRef<unknown>;

  private dialogRef?: MatDialogRef<unknown>;
  updateEquipmentsToCompare = output<void>();
  check = signal<boolean>(false);
  disabled = signal<boolean>(false);

  constructor() {
    effect(() => {
      this.checkItems();
    });
  }

  openModalContactCard(): void {
    this.dialogRef = this.dialog.open(this.modalContactCard, {
      maxWidth: '943px',
      width: '100%',
      maxHeight: '90vh',
      panelClass: 'formOffer',
    });
  }

  close(): void {
    this.dialogRef?.close();
  }

  goToEquipment(): void {
    const card = this.card();

    this.router.navigate([
      `/equipo-usado/categorias/${card.subCategory.category.slug}/${card.subCategory.slug}/${card.economicNumber}`,
    ]);
  }

  update(isChecked: boolean, equipment: EquipmentListSubcategory, event?: any): void {
    let hasItems = false;
    let currentSubCat = '';
    this.compareService.products.subscribe({
      next: (result) => {
        if (result.length > 0) {
          hasItems = true;
          currentSubCat = result[0].subCategory.slug;
        } else {
          hasItems = false;
          currentSubCat = '';
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
    if (!hasItems) {
      if (isChecked) {
        this.compareService.addProduct(equipment);
      } else {
        this.compareService.deleteProduct(equipment.economicNumber);
      }
    } else {
      if (currentSubCat === equipment.subCategory.slug) {
        if (isChecked) {
          this.compareService.addProduct(equipment);
        } else {
          this.compareService.deleteProduct(equipment.economicNumber);
        }
      } else {
        event.source.checked = false;
        this._snackBar.open('Sólo puedes comparar equipos de la misma categoría', 'OK', {
          duration: 5000,
        });
      }
    }
    this.updateEquipmentsToCompare.emit();
    this.checkItems();
  }

  checkItems(): void {
    this.compareService.products.subscribe({
      next: (result) => {
        const foundItem = result.find(
          (option) => option.economicNumber === this.card().economicNumber,
        );
        if (foundItem) {
          this.check.set(true);
        } else {
          this.check.set(false);
        }
        if (result.length === 4) {
          this.disabled.set(true);
        } else {
          this.disabled.set(false);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
}
